<template>
  <div class="VueTables">
    <div class="table-responsive">
      <table class="VueTables__table table is-bordered is-fullwidth background-table">
        <thead class="not-stripped">
        <th class="width-205px">{{ $t('echeancierPaiement.dateEcheance') }}</th>
        <th class="is-220px-width">{{ $t('echeancierPaiement.montantTTC') }}</th>
        <th v-if="sens === sensAchat">{{ $t('echeancierPaiement.modePaiement') }}</th>
        <th v-else>{{ $t('echeancierPaiement.modeReglement') }}</th>
        <th>{{ $t('echeancierPaiement.commentaire') }}</th>
        <th class="colonneSelected"></th>
        <th class="colonneSelected"></th>
        </thead>
        <tbody v-for="(ligneEcheancier, index) in echeancier" :key="index">
        <tr :class="[
          {'stripped': index % 2 === 0 && ligneEcheancier.actif},
          {'not-stripped': index % 2 !== 0 && ligneEcheancier.actif},
          {'has-background-annuler': index % 2 === 0 && !ligneEcheancier.actif},
          {'has-background-selectPrev': index % 2 !== 0 && !ligneEcheancier.actif}]">
          <td>
            <b-datepicker show-week-number
              nearby-selectable-month-days
              v-model="ligneEcheancier.dateEcheance"
              icon="calendar-today"
              :disabled="isDisabled(ligneEcheancier)"
              :editable='!isDisabled(ligneEcheancier)'>
            </b-datepicker>
          </td>
          <td>
            <input-currency isNumber="true"
                            :class="{'disabled' : isDisabled(ligneEcheancier)}"
                            v-model="ligneEcheancier.montant"
                            @input="changeMontant()">
            </input-currency>
          </td>
          <td>
            <b-select v-model="ligneEcheancier.modeReglementId" expanded
                    :class="{'disabled' : isDisabled(ligneEcheancier)}">
              <option v-for="mode in modesReglement"
                      :key="mode.id"
                      :value="mode.id">
                {{mode.libelle}}
              </option>
            </b-select>
          </td>
          <td>
            <b-input type="textarea" :rows="3"
                            :class="{'disabled' : isDisabled(ligneEcheancier, true)}"
                            v-model="ligneEcheancier.commentaire">
            </b-input>
          </td>
          <td class="has-text-centered">
            <a @click="archiver(index, ligneEcheancier.actif)"
               :class="{'disabled' : isDisabled(ligneEcheancier, true)}">
              <b-icon v-if="!!ligneEcheancier.actif"
                type="is-danger"
                icon="close-circle"
                class="mgt-5px">
              </b-icon>
              <b-icon v-else
                type="is-success"
                icon="arrow-up-bold-circle"
                class="mgt-5px">
              </b-icon>
            </a>
          </td>
          <td class="has-text-centered">
            <b-tooltip
              :label="$t('echeancierPaiement.cantDeleteEcheance')"
              :active="ligneEcheancier.estRelance"
              position="is-left">
              <a @click="suppprimerEcheance(index)"
                :class="{'disabled' : isDisabled(ligneEcheancier, true)
                  || ligneEcheancier.estRelance }">
                <b-icon icon="delete-forever" type="is-danger" class="mgt-5px"></b-icon>
              </a>
            </b-tooltip>
          </td>
        </tr>
        </tbody>
        <td colspan="1">
        </td>
        <td class="has-text-right"> {{montant | formatDevise }} / {{montantTtc | formatDevise}}
        </td>
        <td colspan="4"></td>
        <tr>
          <td colspan="2">
            <div class="level">
              <div class="level-item has-text-centered">
                <a class="button is-primary" @click="addLigne">
                  {{ $t('echeancierPaiement.ajouterEcheance')}}
                </a>
              </div>
              <div class="level-item has-text-centered">
                <b-tooltip
                  :label="$t('echeancierPaiement.cantGenerate')"
                  :active="canDeleteEcheancier"
                  position="is-right">
                  <a class="button is-primary"
                    :class="{'disabled' : canDeleteEcheancier}"
                    @click="supprimerEcheancier">
                    {{ $t('echeancierPaiement.supprimerEcheancier')}}
                  </a>
                </b-tooltip>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import { NON_LETTRE } from '@/configuration/lettrageConf';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import { SENS_ACHAT } from '@/configuration/devisConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'FactureEcheancier',
  data() {
    return {
      montant: this.montantTtc,
      nonLettre: NON_LETTRE,
      sensAchat: SENS_ACHAT,
    };
  },
  components: {
    inputCurrency,
  },
  props: {
    echeancier: Array,
    montantTtc: Number,
    sens: String,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    modesReglement() {
      if (this.sens === this.sensAchat) {
        return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement)
          .filter((modeReglement) => {
            return modeReglement.actionAchat !== AUCUN;
          });
      }
      return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
    },
    canDeleteEcheancier() {
      const echeances = this.echeancier.find((echeance) => {
        return (echeance.etatLettrage && echeance.etatLettrage !== NON_LETTRE)
          || echeance.estRelance;
      });
      return !!echeances;
    },
  },
  methods: {
    changeMontant() {
      this.montant = 0;
      this.echeancier
        .filter(echeance => echeance.actif)
        .forEach((element) => {
          if (element.montant) this.montant += element.montant;
        });
    },
    setMontant(montantTtc) {
      this.montant = montantTtc;
    },
    addLigne() {
      this.echeancier.push({
        montant: null,
        actif: true,
        etatLettrage: this.nonLettre,
        dateEcheance: null,
      });
    },
    supprimerEcheancier() {
      this.$emit('delete');
    },
    suppprimerEcheance(index) {
      this.$emit('deleteEcheance', index);
      this.changeMontant();
    },
    archiver(index, archive) {
      this.$emit('archiverEcheance', {
        index: index,
        archive: archive,
      });
      this.changeMontant();
    },
    isDisabled(ligne, sansTestActif) {
      return !!(ligne.etatLettrage && ligne.etatLettrage !== this.nonLettre)
        || (!sansTestActif && !ligne.actif);
    },
  },
  mounted() {
    this.changeMontant();
    this.$parent.$on('updateMontant', this.setMontant);
  },
};
</script>

<style scoped>

</style>
